module.exports = __webpack_public_path__ + "static/hero-image-2377a48e820394d514fad998249db49e.jpg";